import af from 'packages/ai-text-plugin/src/assets/translations/af.json';
import de from 'packages/ai-text-plugin/src/assets/translations/de.json';
import en from 'packages/ai-text-plugin/src/assets/translations/en.json';
import es_mx from 'packages/ai-text-plugin/src/assets/translations/es-mx.json';
import fil from 'packages/ai-text-plugin/src/assets/translations/fil.json';
import fr from 'packages/ai-text-plugin/src/assets/translations/fr.json';
import id from 'packages/ai-text-plugin/src/assets/translations/id.json';
import it from 'packages/ai-text-plugin/src/assets/translations/it.json';
import pt_br from 'packages/ai-text-plugin/src/assets/translations/pt-br.json';
import ru from 'packages/ai-text-plugin/src/assets/translations/ru.json';
import tr from 'packages/ai-text-plugin/src/assets/translations/tr.json';
import ua from 'packages/ai-text-plugin/src/assets/translations/ua.json';

export { af, de, en, es_mx, fil, fr, id, it, pt_br, ru, tr, ua };
